import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// `withCredentials: true` makes the browser attach the `sm_session` httpOnly
// cookie set by the backend on login/register. The legacy Bearer header is
// kept as a fallback during the grace window (devices logged in before v60).
const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("sm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;
